export default __webpack_public_path__ + "static/media/james.6d11acd3.png";